// get sso list
export const REQUEST_GET_SSO_LIST = "request_get_sso_list";
export const GET_SSO_LIST_SUCCESS = "get_sso_list_success";
export const GET_SSO_LIST_FAILURE = "get_sso_list_failure";

// get sso redirect url
export const REQUEST_GET_SSO_REDIRECT_URL = "request_get_sso_redirect_url";
export const GET_SSO_REDIRECT_URL_SUCCESS = "get_sso_redirect_url_success";
export const GET_SSO_REDIRECT_URL_FAILURE = "get_sso_redirect_url_failure";
